import isBofhOffer from '@vio/core/src/offer/business/isBofhOffer'
import {SearchOffer} from '@vio/core/src/offer/types/SearchOffer'

export const filterOutVioOffers = (offers: SearchOffer[]) =>
  offers
    .filter(offer => !isBofhOffer(offer))
    .map((offer, index) => ({
      ...offer,
      osoOfferPosition: index + 1
    }))
